import React, { useState, useEffect, useRef } from 'react';
import { Container, Form } from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { partnerViewModel } from '../school/partner.view.model';
import { addTreehouseChallenge, addTreehouseErrors } from '../../../constants/error.constants';
import { useForm } from 'react-hook-form';
import { imageUtils } from '../../../utils/image.utils';
import { PARTNER_CHALLENGES } from '../../../constants/routes.constants';
import { ErrorMessage } from '@hookform/error-message';
import { useAuth } from '../../auth/Auth';
import { nextChallengeViewModel } from '../next_challenge/next.challenge.viewmodel';
import PartnerUnverifiedModal from '../school/PartnerUnverifiedModal';
import LoadButton from '../../common/LoadButton';
import timezones from 'timezones-list';
import isURL from 'validator/lib/isURL';
import ImageCropModal from '../../common/image-crop-rotate/ImageCropModal';
import { agoraViewModel } from '../../common/agora.view.model';
import { agoraChatGroupName } from '../../../utils/utils';

const Event = ({ expertId, appToken, agoraGroupId }) => {
  const _NOT_SELECTED = '';
  const history = useHistory();
  const { fetchAPI, partner } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isSetLoading, setIsSetLoading] = useState(false);
  const [youtubeUrl, setYoutubeUrl] = useState();
  const [youtubeErrors, setYoutubeErrors] = useState(false);
  const [challengeScope, setChallengeScope] = useState("public");
  const [showModal, setShowModal] = useState(false);
  const [time, setTime] = useState();
  const [date, setDate] = useState();
  const [endTime, setEndTime] = useState();
  const [endDate, setEndDate] = useState();
  const [specialTime, setSpecialTime] = useState();
  const [specialDate, setSpecialDate] = useState();
  const [image, setImage] = useState([]);
  const [tagList, setTaglist] = useState([]);
  const [challengeLength, setChallengeLength] = useState(7);
  const [selectedTag, setSelectedTag] = useState([]);
  const [isDisable, setIsDisable] = useState(false);
  const [imageName, setImageName] = useState("");
  const [imageCropPopup, setImageCropPopup] = useState(false);
  const [imageForCrop, setImageForCrop] = useState(null);
  const [timezone, setTimezone] = useState("");
  const [isRoots, setIsRoots] = useState("yes");
  const [showImageError, setShowImageError] = useState(false);
  const [branchOptions, setBranchOptions] = useState([
    // { value: _NOT_SELECTED, label: 'Select...', name: 'Select' }
  ])
  const challengeImage = useRef();
  const { register, watch, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });

  const pageRedirect = () => {
    history.goBack();
  }

  const handleTimezoneChange = (selected) => {
    setTimezone(selected.tzCode)
  }

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 'auto',
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const getInterestBranches = () => {
    fetchAPI(nextChallengeViewModel.getTags, { limit: 99 })
      .then((res) => {
        setTaglist(res);
        res.map((tag) => {
          setBranchOptions(branchOptions => [...branchOptions, { value: tag.id, label: tag.tag, name: tag.tag }])
        })
      })
      .catch((err) => { });
  }

  const onSubmit = handleSubmit(() => {
    const params = getValues();
    if (!image) return setShowImageError(true);
    setIsDisable(true);
    setIsSetLoading(true);
    let tags = [];
    selectedTag.map((tag) => {
      tags.push(tag.value)
    })
    let data = {
      start_date_time: new Date(date + " " + time),
      end_date_time: new Date(endDate + " " + endTime),
      zoom_link: params["zoom_link"].slice(0, 4) !== "http" ? `https://${params["zoom_link"]}` : params["zoom_link"],
      time_zone: params["timezone"],
      is_root: isRoots === "yes" ? true : false,
      created_by: expertId,
      name: params["title"],
      subtitle: params["title"],
      description: params["description"],
      tags: tags,
    };
    if (youtubeUrl) {
      data.youtube_url = youtubeUrl
    }
    try {
      createGroup(data);
    } catch (err) {
      console.error(err);
    }
  })

  const createGroup = async (challenge) => {
    const data = {
      groupname: agoraChatGroupName(challenge.subtitle),
      desc: challenge.description,
      public: true,
      owner: String(expertId),
    };
    const token = appToken;

    try {
      // await agoraViewModel.createGroup(token, data).then((response) => {
        challenge.agora_group_id = agoraGroupId || '';
        const type = partner?.user_type
        partnerViewModel.addEvent(challenge, type).then((res) => {
          partnerViewModel.addEventMedia(res.id, image, type).then((res) => {
            if (!partner.is_verified) {
              setShowModal(true)
            } else {
              history.push(PARTNER_CHALLENGES)
            }
          })
        }).catch((err) => {
          console.log(err)
          // let params = {
          //   appToken: appToken,
          //   id: response.data.groupid
          // }
          // agoraViewModel.deleteGroup(params)
        })
      // });
    } catch (err) {
      console.error(err);
    }
  };

  const handleImageChange = (e) => {
    const files = e.target.files;
    if (files.length) {
      setImageForCrop(files[0])
      setImageCropPopup(true)
    }
  }

  const challengeImageUpload = () => {
    return (
      imageCropPopup && imageForCrop ?
        <ImageCropModal
          imageCropPopup={imageCropPopup}
          setImageCropPopup={setImageCropPopup}
          image={imageForCrop}
          setPicture={onCropComplete}
          heading='Edit your event image'
          aspectRatio={16/9}
        />
        :
        <Form.Group controlId="formFile" className="mb-3 upload-image">
          <FormLabel>Event Image</FormLabel>
          <div className="button-wrap">
            <label className="button gred-btn" onClick={() => challengeImage.current.click()}>Upload image</label>
            <input id="upload" name='challengeImage'
              accept="image/png, image/jpeg, image/jpg, .heic, .HEIC"
              ref={challengeImage} type="file" onChange={(e) => handleImageChange(e)}
            />
            <span className='file-span'>{imageName ? imageName : "No File Selected"}</span>
          </div>
          {showImageError &&
            <p
              name="challengeImage"
              className="small text-danger"
            >Please upload challenge image</p>
          }
        </Form.Group>
    )
  }

  const onCropComplete = (croppedImage) => {
    const imagePromise = imageUtils.getImagePromise(croppedImage);
    imagePromise
      .then((img) => {
        setImageName(img.name)
        setImage(img)
        setImageCropPopup(false)
        setImageForCrop(null)
      })
  }

  const handleBranchAdd = (selectedValue) => {
    // console.log(selectedValue)
    setSelectedTag(selectedValue)
  }

  useEffect(() => {
    getInterestBranches();
    setIsLoading(false)
  }, [])

  const handleYoutube = (e) => {
    if (e.target.value === "") {
      setYoutubeErrors(false)
      setIsDisable(false)
    } else {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
      var match = e.target.value.match(regExp);
      if (match && match[2].length == 11) {
        setYoutubeErrors(false)
        setIsDisable(false)
      }
      else {
        setIsDisable(true)
        setYoutubeErrors("Please enter a valid url")
      }
    }
    setYoutubeUrl(e.target.value)
  }

  return (
    <>
      <PartnerUnverifiedModal showModal={showModal} setShowModal={setShowModal} />
      <Container>
        <div className="d-flex justify-content-center">
          <div className='a-challenge-partner'>
            {/* <h2 className='mb-60'>Set a challenge</h2>

            <div className='set-challenge-avtar'>
              <img src={partner ? partner.picture_url : setUserAvtar} alt='' />
            </div> */}

            <Form className='mt-50 mb-40' onSubmit={onSubmit}>
              <Form.Group className="mb-3" controlId="">
                <FormLabel>Title</FormLabel>
                <FormInput
                  name="title"
                  className="form-input"
                  ref={register({
                    required: addTreehouseChallenge.title.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="title"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  name="description"
                  as="textarea"
                  rows="3"
                  ref={register({
                    required: addTreehouseChallenge.description.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="description"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <Form.Label>Youtube url</Form.Label>
                <FormInput
                  name="youtube_url"
                  className="form-input"
                  value={youtubeUrl}
                  onChange={handleYoutube}
                />
                <p className='pt-2 small text-danger'>
                  {youtubeErrors}
                </p>
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <Form.Label>Select interest branches</Form.Label>
                <Select
                  name="hash_tag"
                  options={branchOptions}
                  isMulti
                  styles={customStyles}
                  required
                  value={selectedTag}
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '6px',
                    colors: {
                      ...theme.colors,
                      primary: '#80e4e1',
                    },
                  })}
                  onChange={handleBranchAdd}
                  inputRef={register({
                    required: addTreehouseChallenge.hast_tag.required,
                  })}
                />

                <ErrorMessage
                  errors={errors}
                  name="hash_tag"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              {challengeImageUpload()}

              <Form.Group className="mb-3" controlId="">
                <FormInput
                  name="zoom_link"
                  className="form-input"
                  placeholder="Enter link to zoom / google meets"
                  data-testid="zoom_link"
                  ref={register({
                    required: addTreehouseChallenge.zoom_link.required,
                    validate: (input) =>
                      isURL(input) || addTreehouseChallenge.zoom_link.invalid,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="zoom_link"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <FormLabel>Event start date</FormLabel>
                <FormInput
                  type="date"
                  name="date"
                  min={new Date().toISOString().slice(0, 10)}
                  className="form-input"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.date.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="date"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <FormLabel>Event start time</FormLabel>
                <FormInput
                  type="time"
                  name="time"
                  className="form-input"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.time.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="time"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              {/* <Form.Group className="mb-3" controlId="">
                <FormLabel>Event end date</FormLabel>
                <FormInput
                  type="date"
                  name="endDate"
                  min={date ? new Date(date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
                  className="form-input"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.endDate.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="endDate"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <FormLabel>Event end time</FormLabel>
                <FormInput
                  type="time"
                  name="endTime"
                  className="form-input"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.endTime.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="endTime"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group> */}

              <Form.Group className="mb-3" controlId="">
                <FormLabel>Event end date</FormLabel>
                <FormInput
                  type="date"
                  name="endDate"
                  min={date ? new Date(date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)}
                  className="form-input"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.endDate.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="endDate"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <FormLabel>Event end time</FormLabel>
                <FormInput
                  type="time"
                  name="endTime"
                  className="form-input"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  ref={register({
                    required: addTreehouseChallenge.endTime.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="endTime"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="">
                <Form.Label>Time zone</Form.Label>
                <Select
                  options={timezones}
                  styles={customStyles}
                  name="timezone"
                  theme={(theme) => ({
                    ...theme,
                    borderRadius: '6px',
                    colors: {
                      ...theme.colors,
                      primary: '#80e4e1',
                    },
                  })}
                  onChange={handleTimezoneChange}
                />
                <input
                  type="hidden"
                  name="timezone"
                  value={timezone}
                  ref={register({
                    required:
                      addTreehouseErrors.timezone.required,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="timezone"
                  className="small text-danger"
                  as="label"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="">
                <Form.Label>Roots and Branches only?</Form.Label>
                <div key={`inline-radio`} className="mb-3">
                  <Form.Check
                    inline
                    label="Yes"
                    name="group1"
                    value="yes"
                    type="radio"
                    id={`inline-radio-1`}
                    defaultChecked
                    onClick={() => setIsRoots("yes")}
                  />
                  <Form.Check
                    inline
                    label="No"
                    value="no"
                    name="group1"
                    type="radio"
                    onClick={() => setIsRoots("no")}
                    id={`inline-radio-2`}
                  />
                </div>
              </Form.Group>
              <LoadButton
                type="submit"
                text="Set live event"
                className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                isDisabled={isDisable}
                isLoading={isLoading}
              />
            </Form>
          </div>
        </div>
      </Container>
    </>
  )
}
export default Event;